export default {
    namespaced: true,
    state: {
      windowWidth: 0,
      theme: 'dark',
      language: 'ru',
      sideBarIsOpen: true,
    },

    mutations: {
      SET_WINDOW_WIDTH(state, value) {
        state.windowWidth = value;
      },
      SET_THEME(state, newTheme) {
        state.theme = newTheme;
      },
      SET_LANGUAGE(state, language) {
        state.language = language;
      },
      SET_SIDE_BAR_IS_OPEN(state) {
        state.sideBarIsOpen = !state.sideBarIsOpen;
      }
    },

    actions: {
      toggleTheme({ commit, state }) {
        const newMode = state.theme === 'light' ? 'dark' : 'light';
        commit('SET_THEME', newMode);
        
        // Обновляем класс на корневом элементе, который используется как darkModeSelector
        document.documentElement.classList.toggle('my-app-dark', newMode === 'dark');
      },
      setTheme({ commit }, mode) {
        commit('SET_THEME', mode);
        document.documentElement.classList.toggle('my-app-dark', mode === 'dark');
      }
    },
  
    getters: {
      isMobile: (state) => state.windowWidth <= 768,
      theme: (state) => state.theme,
      isDark: (state) => state.theme === 'dark',
      currentLanguage: (state) => state.language,
      sideBarIsOpen: (state) => state.sideBarIsOpen,
    },
  };